import $ from 'jquery'
import {Errors, FormState} from 'mixins/FormTypes'
import FormErrors from './errors'

type FormData = {
  [field: string]: any
}

class Form {
  public errors = new FormErrors()
  public busy = false
  public successful = false

  constructor(formData: FormData) {
    $.extend(this as any, formData)
  }

  /**
   * Start processing the form.
   */
  startProcessing = (state: FormState) => {
    this.errors.forget()
    this.busy = true
    this.successful = false

    state.state.setState({
      form: state.form
    })
  }

  /**
   * Finish processing the form.
   */
  finishProcessing = (state: FormState) => {
    this.busy = false
    this.successful = true

    state.state.setState({
      form: this
    })
  }

  /**
   * Reset the errors and other state for the form.
   */
  resetStatus = () => {
    this.errors.forget()
    this.busy = false
    this.successful = false
  }


  /**
   * Set the errors on the form.
   */
  setErrors = ({form, state}: FormState, errors: Errors) => {
    form.busy = false
    form.errors.set(errors)

    state.setState({
      form: form
    })
  }
}

export default Form
